import { Box, useTheme, Typography } from "@mui/material";
import { Helmet } from "react-helmet";
import React, { useState } from "react";
import GridContainer from "../../components/grid/GridContainer.jsx";
import GridItem from "../../components/grid/GridItem.jsx";
import { getLeranMoreStyle } from "../../components/customstyles/LearnMoreStyle.jsx";
import Breadcrumbs from "./Breadcrumbs";

const useStyles = () => {
  let theme = useTheme();
  return getLeranMoreStyle(theme);
};

function DentalStatus() {
  const styles = useStyles();
  const [loadingStarted, setLoading] = useState(true);

  const handleDentalLoading = () => {
    setLoading(false);
  };
  return (
    <Box sx={styles.learnMorePageStyle}>
      <Helmet>
        <title>Patients</title>
      </Helmet>
      <Breadcrumbs handleLoading={handleDentalLoading} name={"Dental Status"} />
      {!loadingStarted && (
        <div className="FSUnmask">
          <GridContainer>
            <GridItem
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ marginTop: "30px" }}
            >
              <Box>
                <Typography sx={styles.learnMoreHeading}>
                  Dental Status
                </Typography>
              </Box>

              <Box sx={{ marginTop: "30px" }}>
                <Typography sx={styles.bodyAreasText}>
                  Dental problems, such as ill-fitting dentures, missing teeth,
                  or oral pain, can mimic or exacerbate abnormal movements,
                  potentially leading to misinterpretation of symptoms during
                  the AIMS assessment. That is why it’s important to ask the
                  patient if they wear dentures and if their teeth or dentures
                  are bothersome.
                </Typography>
              </Box>
              <Box sx={{ marginTop: "20px" }}>
                <Typography sx={styles.bodyAreasText}>
                  Addressing dental issues identified during the AIMS assessment
                  may help reduce confounding factors in future assessments. For
                  example, resolving denture-related discomfort may eliminate
                  unnecessary movements unrelated to TD.
                </Typography>
              </Box>
            </GridItem>
          </GridContainer>
        </div>
      )}
    </Box>
  );
}

export default DentalStatus;
